module.exports = __webpack_public_path__ + "media/images/tracera_logo-e478dfcde30c8abddfad7c815bc6296a.png";